module.exports = __webpack_public_path__ + "img/LVIV.9d3a91e8.jpg";